import { useCallback, useState } from "react";

const ENDPOINT = "/forms/handle_form.php";

/**
 * Submits a form's FormData to the PHP mailer endpoint via fetch, so the
 * page never reloads. The endpoint responds with JSON
 * ({ success, message } or { success: false, errors: [...] }).
 */
export default function useFormSubmit() {
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [errors, setErrors] = useState([]);

  const submit = useCallback(async (formElement) => {
    setStatus("submitting");
    setErrors([]);

    try {
      const response = await fetch(ENDPOINT, {
        method: "POST",
        body: new FormData(formElement),
        headers: { Accept: "application/json" },
      });

      let payload = null;
      try {
        payload = await response.json();
      } catch {
        payload = null;
      }

      if (response.ok && payload?.success) {
        setStatus("success");
        formElement.reset();
        return true;
      }

      setErrors(payload?.errors?.length ? payload.errors : ["Une erreur est survenue. Merci de réessayer ou de nous contacter directement."]);
      setStatus("error");
      return false;
    } catch {
      setErrors(["Impossible d’envoyer le message pour le moment. Vérifiez votre connexion ou contactez-nous directement."]);
      setStatus("error");
      return false;
    }
  }, []);

  const reset = useCallback(() => {
    setStatus("idle");
    setErrors([]);
  }, []);

  return { status, errors, submit, reset };
}
